import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  DataGrid,
  Grid,
  Table,
} from '../../components/index';
import Exigencia from './Exigencia';
import { requestExigencias, requestMotivos } from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';

class CumprimentoExigencia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acaoModal: 'Inclusão de Exigência',
      exigenciaSelecionada: null,
      showModal: false,
    };
  }

  failCallback = () => {
    this.alteraEstado(6);
  }

  handleModal = (callback) => {
    if (callback) {
      this.setState({ showModal: !this.state.showModal }, callback);
    } else {
      this.setState({ showModal: !this.state.showModal });
    }
  }

  mostraModal = (e, acaoModal) => {
    this.setState({ acaoModal, exigenciaSelecionada: null }, this.handleModal);
  }

  escondeModal = () => {
    this.handleModal();
  }

  alteraExigencia = (exigencia, title) => {
    this.setState({ acaoModal: title, exigenciaSelecionada: exigencia }, this.handleModal);
  }

  salvaExigencia = (exigencia) => {
    const { exigencias } = { ...this.props.requerimento };
    exigencias[exigencia.index] = exigencia;
    this.handleModal(this.props.handleChange({
      value: exigencias,
      isValid: true,
    }, 'exigencias'));
  }

  deleteExigencia = (index) => {
    const { exigencias } = { ...this.props.requerimento };
    exigencias.splice(index, 1);
    this.props.handleChange({
      value: exigencias,
      isValid: true,
    }, 'exigencias');
  }

  createActionColumn = (index, exigencia) => (
    <React.Fragment>
      <Button
        hint="Cumprir exigência"
        icon="ico-pencil"
        mini
        onClick={() => this.alteraExigencia(exigencia, 'Cumprir exigência')}
      />
    </React.Fragment>
  );

  addDependenteLabel = (dependenteSelecionado) => {
    if (dependenteSelecionado) {
      const dependentesFormatados = this.props.requerimento.dependentes.map(dependente => (
        {
          label: dependente.nome,
          value: dependente.codigo,
        }
      ));
      return listUtils.getObject(dependentesFormatados, dependenteSelecionado).label;
    }
    return null;
  }

  doRequest = (typeRequest) => {
    switch (typeRequest) {
      case 'exigencia':
        if (this.props.exigencias.length === 0) {
          requestExigencias(this.failCallback);
        }
        break;
      case 'motivo':
        if (this.props.motivosIndeferimento.length === 0 ||
          this.props.motivosSuspensao.length === 0 ||
          this.props.motivosNaoCumprimento.length === 0) {
          requestMotivos(this.failCallback);
        }
        break;
      default:
        break;
    }
  }

  diffTipoRequerimento = () => (this.props.requerimento.tipoAposentadoria)

  exigenciasTableHeaderAposentadoria = [{
    id: 'acao',
    label: 'Ação Exigida',
  }, {
    id: 'comentario',
    label: 'Comentário',
  }, {
    id: 'index',
    label: null,
    dataFormat: this.createActionColumn,
  }];

  exigenciasTableHeaderPensao = [{
    id: 'acao',
    label: 'Ação Exigida',
  }, {
    id: 'codigoDependente',
    label: 'Dependente',
    dataFormat: this.addDependenteLabel,
  }, {
    id: 'comentario',
    label: 'Comentário',
  }, {
    id: 'index',
    label: null,
    dataFormat: this.createActionColumn,
  }];

  render() {
    let modal;

    const options = {
      noDataText: 'Nenhuma exigência para o requerimento',
    };

    const { exigencias } = { ...this.props.requerimento };
    const listaExigenciasIndexada = exigencias.map((item, i) => {
      const itemIndexado = item;
      itemIndexado.index = i;
      return itemIndexado;
    });

    if (this.state.showModal) {
      modal = (
        <Exigencia
          cumprimentoExigencia
          exigencias={this.props.exigencias}
          dependentes={this.props.requerimento.dependentes}
          tipoRequerimento={this.diffTipoRequerimento() ? 'aposentadoria' : 'pensao'}
          salvaExigencia={this.salvaExigencia}
          exigencia={this.state.exigenciaSelecionada}
          onHide={this.escondeModal}
          title={this.state.acaoModal}
          showModal
          size="md"
          userData={this.props.userData}
          motivosNaoCumprimento={this.props.motivosNaoCumprimento}
        />
      );
    }

    return (
      <React.Fragment>
        <DataGrid title="Cumprimento de exigências" icon="ico-process-check" >
          <div className="row">
            <Grid cols="12 12 12 12">
              <Table
                bordered
                data={listaExigenciasIndexada}
                insertRow
                options={options}
                listaTableHeader={
                this.diffTipoRequerimento()
                  ? this.exigenciasTableHeaderAposentadoria
                  : this.exigenciasTableHeaderPensao
                }
              />
            </Grid>
          </div>
        </DataGrid>
        { modal }
      </React.Fragment>
    );
  }
}

CumprimentoExigencia.propTypes = {
  handleChange: PropTypes.func.isRequired,
  requerimento: PropTypes.shape({
    estado: PropTypes.number,
    exigencias: PropTypes.shape({
      tipo: PropTypes.number,
      comentario: PropTypes.string,
    }),
    tipoAposentadoria: PropTypes.number,
    motivo: PropTypes.number.isRequired,
    dependentes: PropTypes.array,
  }).isRequired,
  exigencias: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  motivosIndeferimento: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  motivosNaoCumprimento: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  motivosSuspensao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  userData: PropTypes.objectOf(PropTypes.object),
};

CumprimentoExigencia.defaultProps = {
  motivosIndeferimento: null,
  motivosSuspensao: null,
  motivosNaoCumprimento: null,
  exigencias: null,
  userData: null,
};

const mapStateToProps = state => ({
  exigencias: state.base.exigencias,
  motivosIndeferimento: state.base.motivosIndeferimento,
  motivosSuspensao: state.base.motivosSuspensao,
  motivosNaoCumprimento: state.base.motivosNaoCumprimento,
});

export default connect(mapStateToProps)(CumprimentoExigencia);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/CumprimentoExigencia.jsx